import { WhatsappLinkButtonComponent } from '@edt/components/atoms/whatsapp-link-button/whatsapp-link-button.component';
import { NgClass } from '@angular/common';
import { Component, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { SvgComponent } from '@edt/components/atoms/svg/svg.component';
import {
  FooterIconLink,
  FooterTextLink,
  HelpButton,
  LinksCollection,
  SiteInfo,
  TYPE_REFERENCE_SVG,
} from '@edt/models/footer';
import { IsExternalUrlPipe } from '@edt/pipes/is-external-url.pipe';
import { SafehtmlPipe } from '@edt/pipes/safehtml.pipe';

export const DEFAULT_FOOTER_DATA = {
  links: [
    {
      title: 'Enlaces',
      links: [
        { text: 'Programa evento', href: '/program' },
        {
          text: 'Concurso gastronomía',
          href: '/gastronomy_contest',
        },
        {
          text: 'Concurso de coctelería',
          href: '/cocktail_contest',
        },
        {
          text: 'Concurso de fotografía',
          href: '/photo_contest',
        },
      ],
    },
    {
      title: 'Sitios de interes',
      links: [{ text: 'Granma Travel', href: 'http://www.granma.travel' }],
    },
  ],
  secondaryLinks: [
    { text: 'Términos y condiciones', href: '/terms' },
    { text: 'Políticas de privacidad', href: '/privacy' },
  ],
  socialLinks: [
    {
      ariaLabel: 'X',
      icon: '<svg class="h-5 w-5" data-icon="tabler:brand-x" height="1em" width="1em"><symbol id="ai:tabler:brand-x" viewBox="0 0 24 24"><path d="m4 4l11.733 16H20L8.267 4zm0 16l6.768-6.768m2.46-2.46L20 4" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path></symbol><use href="#ai:tabler:brand-x"></use></svg>',
      type: 'SVG_ELEMENT' as TYPE_REFERENCE_SVG,
      href: 'https://twitter.com/GranmaTravel',
    },
    {
      ariaLabel: 'Instagram',
      icon: '<svg class="h-5 w-5" data-icon="tabler:brand-instagram" height="1em" width="1em"><symbol id="ai:tabler:brand-instagram" viewBox="0 0 24 24"><g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path d="M4 8a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4z"></path><path d="M9 12a3 3 0 1 0 6 0a3 3 0 0 0-6 0m7.5-4.5v.01"></path></g></symbol><use href="#ai:tabler:brand-instagram"></use></svg>',
      type: 'SVG_ELEMENT' as TYPE_REFERENCE_SVG,
      href: 'https://www.instagram.com/granmatravel',
    },
    {
      ariaLabel: 'Facebook',
      icon: '<svg class="h-5 w-5" data-icon="tabler:brand-facebook" height="1em" width="1em"><symbol id="ai:tabler:brand-facebook" viewBox="0 0 24 24"><path d="M7 10v4h3v7h4v-7h3l1-4h-4V8a1 1 0 0 1 1-1h3V3h-3a5 5 0 0 0-5 5v2z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path></symbol><use href="#ai:tabler:brand-facebook"></use></svg>',
      type: 'SVG_ELEMENT' as TYPE_REFERENCE_SVG,
      href: 'https://www.facebook.com/AmbiguBayames',
    },
  ],
  footNote: `
    Desarrollado por <a class="text-blue-600 hover:underline dark:text-gray-200" href="http://edtsoft.cu/"> EDT Soft S.R.L</a> · Todos los derechos reservados.
  `,
  helpButton: {
    show: false,
    label: '',
    phoneNumber: '',
    message: '',
  },
};

const DEFAULT_SITE_INFO = {
  name: 'Your Site Name',
  slogan: 'Your Site Slogan',
};

@Component({
  selector: 'edt-footer',
  standalone: true,
  imports: [
    MatIconModule,
    MatButtonModule,
    RouterLink,
    IsExternalUrlPipe,
    NgClass,
    SafehtmlPipe,
    SvgComponent,
    WhatsappLinkButtonComponent,
  ],
  templateUrl: './footer.component.html',
})
export class FooterComponent {
  links = input<LinksCollection<FooterTextLink>[]>(DEFAULT_FOOTER_DATA.links);
  secondaryLinks = input<FooterTextLink[]>(DEFAULT_FOOTER_DATA.secondaryLinks);
  socialLinks = input<FooterIconLink[]>(DEFAULT_FOOTER_DATA.socialLinks);
  footNote = input(DEFAULT_FOOTER_DATA.footNote);
  siteInfo = input<SiteInfo>(DEFAULT_SITE_INFO);
  helpButton = input<HelpButton>(DEFAULT_FOOTER_DATA.helpButton);

  linkStyles = input('hover:text-gray-700 hover:underline dark:text-gray-400');
  headerStyles = input('text-white dark:text-gray-300 ');
  socialStyle = input('text-sm');

  footNoteStyle = input('text-sm mr-4 dark:text-slate-400');
}
